import React from 'react'
import { Hourglass } from 'lucide-react'

/**
 * Simple splash for coming soon features
 */
export default function ComingSoonPage() {
  return (
    <div className="flex flex-col items-center justify-center h-full text-gray-300 space-y-4">
      <Hourglass className="w-12 h-12 text-amber-500 animate-pulse" />
      <h1 className="text-3xl font-bold">Coming Soon</h1>
      <p className="text-center max-w-sm">
        Were working hard to bring you this feature. Stay tuned for its release!
      </p>
    </div>
  )
}